import Base from "./base.service.js";
export default class Quality extends Base {
    constructor() {
        super("quality");
    }
}
